import { defineMessages } from 'react-intl';

export default defineMessages({
  text: {
    id: 'MovedOrderAlert.text',
    defaultMessage:
      'Order {orderReference} successfully moved to the account of {emailAddress}. You can <link>view the history log</link> for this action.',
  },
});
